import { Outlet } from 'react-router-dom'
import AdminNavbar from './AdminNavbar'
import { ProgressBar } from 'react-bootstrap'
import { useContext } from 'react'
import { AuthContext } from '../AuthContext'

const AdminLayout = ({
  currentUser,
  setCurrentUser,
  loginShow,
  setLoginShow,
  handleLogout,
}) => {
  const { isLoading } = useContext(AuthContext)

  return (
    <div className="d-flex layout">
      <AdminNavbar
        currentUser={currentUser}
        setCurrentUser={setCurrentUser}
        loginShow={loginShow}
        setLoginShow={setLoginShow}
        handleLogout={handleLogout}
      />
      <div
        style={{
          marginLeft: '250px', // 新增：為固定的 navbar 預留空間，根據 navbar 寬度調整
          width: 'calc(100% - 250px)', // 新增：調整內容區域寬度
          minHeight: '100vh', // 新增：確保最小高度
        }}
      >
        {isLoading ? (
          <div className="m-5 w-100 text-center">
            <ProgressBar className="m-4" animated now={100} />
            <h5 className="text-secondary">資料等待中...</h5>
          </div>
        ) : (
          <Outlet />
        )}{' '}
      </div>
    </div>
  )
}

export default AdminLayout
